import { Box, Link, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function RegistrationComplete() {
  const { t } = useTranslation();
  return (
    <>
      <Typography variant="h5" align="center" sx={{ marginBottom: 10 }}>
        {t('download_app')}
      </Typography>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Stack direction="row" spacing={1}>
          <Link href="https://apps.apple.com/us/app/fast-ai-clinical/id6449023550" underline="none">
            <img alt="Download on the App Store" src="/images/Appstore.svg" />
          </Link>
          <Link href="https://play.google.com/store/apps/details?id=tech.fast" underline="none">
            <img style={{ width: 120, height: 40 }} alt="Get it on Google Play" src="/images/GooglePlay.png" />
          </Link>
        </Stack>
      </Box>
    </>
  );
}
